import { connect } from 'react-redux';
import { State } from 'store/state';
import { createSelector } from 'reselect';
import { afterUploadBulletinModalStateSelector } from 'store/state/app/selectors';
import { setAfterUploadBulletinModalOpen } from 'store/state/app/actions';
import { AfterUploadModalView } from './AfterUploadBulletinPopup';
import { isPrivateUserSelector } from 'store/state/domainData/selectors';

const afterUploadModalPropsSelector = createSelector(
  afterUploadBulletinModalStateSelector,
  modal => ({
    popupStatus: modal ? modal.uploadType : null,
    poi: modal ? modal.poi : null,
  })
);

const mapStateToProps = (state: State) => ({
  ...afterUploadModalPropsSelector(state),
  isPrivateUser: isPrivateUserSelector(state),
});

const mapDispatchToProps = {
  onClosePopup: () => setAfterUploadBulletinModalOpen(null),
};

export default connect(mapStateToProps, mapDispatchToProps)(AfterUploadModalView);
